"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paginator = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _iconButton = require("../icon-button");

var _SvgBtDoubleLeftChevron = require("../svg/icons/SvgBtDoubleLeftChevron");

var _SvgBtDoubleRightChevron = require("../svg/icons/SvgBtDoubleRightChevron");

var _SvgBtLeftChevron = require("../svg/icons/SvgBtLeftChevron");

var _SvgBtRightChevron = require("../svg/icons/SvgBtRightChevron");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c89a060ed{display:flex;align-items:center;font-size:.75rem;font-weight:400;line-height:.8125rem;color:var(--color-flomni-gray-70)}.cb48f5a11{padding-right:.1875rem}.ce64248ea{padding-left:.1875rem}.c1405114d{display:flex;align-items:center;padding:0 .4375rem}.cd602d7af{padding-left:.375rem;padding-right:.375rem;-webkit-user-select:none;-ms-user-select:none;user-select:none}.c5dbea1dc{cursor:pointer}.c5dbea1dc:hover{opacity:.7}.ce610fdb8{color:var(--color-flomni-blue-70);font-size:.75rem;font-weight:500;line-height:.8125rem}");
var styles = {
  root: 'c89a060ed',
  'arrow-left': 'cb48f5a11',
  'arrow-right': 'ce64248ea',
  pages: 'c1405114d',
  'page-cnt': 'cd602d7af',
  '--page-unselected': 'c5dbea1dc',
  '--page-selected': 'ce610fdb8'
};

var Paginator = function Paginator(props) {
  var goToPage = props.goToPage,
      length = props.length,
      selectedPage = props.selectedPage,
      displayLength = props.displayLength,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var pages = (0, _react.useMemo)(function () {
    var actualLength = displayLength > length ? length : displayLength;
    var page;
    return new Array(actualLength).fill(1).map(function (item, index) {
      if (index !== 0) return ++page;
      var first = selectedPage - (actualLength - 1) / 2;
      var last = selectedPage + (actualLength - 1) / 2;
      page = first < 1 ? 1 : last > length ? length - actualLength + 1 : Math.ceil(first);
      return page;
    });
  }, [displayLength, length, selectedPage]);
  var onNextClickHandler = (0, _react.useCallback)(function () {
    goToPage(selectedPage + 1);
  }, [goToPage, selectedPage]);
  var onBackClickHandler = (0, _react.useCallback)(function () {
    goToPage(selectedPage - 1);
  }, [goToPage, selectedPage]);
  var onStartClickHandler = (0, _react.useCallback)(function () {
    goToPage(1);
  }, [goToPage]);
  var onEndClickHandler = (0, _react.useCallback)(function () {
    goToPage(length);
  }, [goToPage, length]);
  var onPageClickHandlers = (0, _react.useMemo)(function () {
    return pages.map(function (item) {
      return function () {
        goToPage(item);
      };
    });
  }, [goToPage, pages]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.arrow.left
  }, /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    size: "small",
    onClick: onStartClickHandler,
    disabled: selectedPage === 1
  }, /*#__PURE__*/_react.default.createElement(_SvgBtDoubleLeftChevron.SvgBtDoubleLeftChevron, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.arrow.left
  }, /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    size: "small",
    onClick: onBackClickHandler,
    disabled: selectedPage === 1
  }, /*#__PURE__*/_react.default.createElement(_SvgBtLeftChevron.SvgBtLeftChevron, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.pages
  }, pages.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: (0, _classnames.default)(cn.page.cnt, (0, _defineProperty2.default)({}, cn.page.selected, item === selectedPage), (0, _defineProperty2.default)({}, cn.page.unselected, item !== selectedPage)),
      onClick: onPageClickHandlers[index]
    }, item);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.arrow.right
  }, /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    size: "small",
    onClick: onNextClickHandler,
    disabled: selectedPage === length
  }, /*#__PURE__*/_react.default.createElement(_SvgBtRightChevron.SvgBtRightChevron, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.arrow.right
  }, /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    size: "small",
    onClick: onEndClickHandler,
    disabled: selectedPage === length
  }, /*#__PURE__*/_react.default.createElement(_SvgBtDoubleRightChevron.SvgBtDoubleRightChevron, null))));
};

exports.Paginator = Paginator;
Paginator.propTypes = {
  /* component logic props */
  goToPage: _propTypes.func.isRequired,
  length: _propTypes.number.isRequired,
  displayLength: _propTypes.number.isRequired,
  selectedPage: _propTypes.number.isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
Paginator.defaultProps = {
  classes: {}
};